import translations from './translations'

export default {
  install (Vue) {
    Vue.prototype.$t = function (key) {
      const mode = this.$store.getters.easyLanguage ? 'easy' : 'standard'
      return translations[mode][key] ?? translations.standard[key] ?? key
    }
  }
}
